<template>
  <transition name="notify-fade">
    <div
      v-if="notify.visible"
      class="notify-wrapper"
      role="alert"
    >
      <div class="notify-inner" :class="'notify--' + notify.type">
        <div class="notify-icon">
          <span v-if="notify.type === 'success'">✔</span>
          <span v-else-if="notify.type === 'danger'">⚠</span>
          <span v-else>ℹ</span>
        </div>

        <div class="notify-text">
          {{ notify.text }}
        </div>

        <button class="notify-close" type="button" @click="close">
          ✕
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import store from '@/store';

export default {
  name: 'NotifyBar',
  computed: {
    notify() {
      return store.notify;
    }
  },
  methods: {
    close() {
      store.hideNotify();
    }
  }
};
</script>

<style scoped>
.notify-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99999; /* En üstte */
  display: flex;
  justify-content: center;
  pointer-events: none; /* Dışına tıklamaları engellememek için */
}

.notify-inner {
  pointer-events: auto;
  width: 100%;
  max-width: 1200px; /* İstersen kaldır, tamamen 100% olsun */
  margin: 0 8px;
  padding: 10px 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  box-sizing: border-box;
}

/* Tip bazlı renkler */
.notify--success {
  background: #e6ffed;
  border: 1px solid #52c41a;
}

.notify--danger {
  background: #fff1f0;
  border: 1px solid #ff4d4f;
}

.notify--info {
  background: #e6f7ff;
  border: 1px solid #1890ff;
}

.notify-icon {
  margin-right: 10px;
  font-size: 18px;
}

.notify-text {
  flex: 1;
  font-size: 14px;
}

.notify-close {
  border: none;
  background: transparent;
  font-size: 16px;
  cursor: pointer;
  margin-left: 10px;
}

/* Transition */
.notify-fade-enter-active,
.notify-fade-leave-active {
  transition: opacity 0.25s, transform 0.25s;
}
.notify-fade-enter,
.notify-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>



// WEBPACK FOOTER //
// src/components/notifyBar.vue